import { Button } from "react-bootstrap";

function BtnNormal() {
  return (
    <>
        <div className="card-body">
            <h4 className="card-title">Normal buttons</h4>
            <p className="card-description">Use any of the available buttons classes to quickly to quickly create a styled button.</p>
            <div className="template-demo">
                <Button variant="primary">Primary</Button>
                <Button variant="secondary">Secondary</Button>
                <Button variant="success">Success</Button>
                <Button variant="danger">Danger</Button>
                <Button variant="warning">Warning</Button>
                <Button variant="info">Info</Button>
                <Button variant="light">Light</Button>
                <Button variant="dark">Dark</Button>
                <Button variant="link">Link</Button>
            </div>
        </div>
    </>
  )
}

export default BtnNormal